module.exports = __webpack_public_path__ + "img/training-title-bg.69293743.png";